import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {ProfileEdit} from './profile-edit/ProfileEdit'

export const ProfilePage = () => {
    return (
        <Routes>
            <Route element={<Outlet />}>
                <Route path='edit' element={<ProfileEdit />} />
            </Route>
            <Route index element={<Navigate to='/profile/edit' />} />
        </Routes>
    )
}
